export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4735.548ac441.jpg";